import { declOfNum } from "../../components/charts/helpers";
import i18n from '../../i18n/i18n.js';

// actions
import {
  TRUST_HOURLY,
  TRUST_DAILY,
  TRUST_COMMENT_DAILY,
  TRUST_PERIOD
} from "../../store/actions/analytics";

export const getPickerOptions = (retrospective, getMethod, chartName) => {
  return {
    disabledDate(time) {
      let nextDate = new Date();

      nextDate.setHours(23);
      nextDate.setMinutes(59);
      nextDate.setSeconds(59);

      let isSafariBr = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

      if (isSafariBr) {
        const search = ' ';
        const replaceWith = 'T';

        retrospective = retrospective.replace(search, replaceWith);
        return time.getTime() < new Date(retrospective) || time.getTime() > nextDate;
      }

      return time.getTime() < new Date(retrospective) || time.getTime() > nextDate;
    },
    firstDayOfWeek: 1,
    onPick(dateObj) {
      console.log('test 2')
      if (dateObj.maxDate) {

        let titles = i18n.t('pickerOptions.onPick.titles');

        const diff = Math.round(( Date.parse(dateObj.maxDate) - Date.parse(dateObj.minDate) ) / 86400000) + 1;

        if (chartName === 'TonalComment') {
          getMethod({
            method: TRUST_COMMENT_DAILY,
            title: `${diff} ${declOfNum(diff, titles)}`
          });
        } else {
          getMethod({
            method: diff === 1 ? TRUST_HOURLY : TRUST_DAILY,
            title: `${diff} ${declOfNum(diff, titles)}`
          });
        }
      }
    },
    shortcuts: [
      {
        text: i18n.t('pickerOptions.shortcuts.today'),
        onClick(picker) {
          console.log('test 3')
          if (chartName === 'TonalComment') {
            getMethod({method: TRUST_COMMENT_DAILY, title: this.text});
          } else {
            getMethod({method: TRUST_HOURLY, title: this.text});
          }

          const endDate = new Date();
          const startDate = new Date();

          startDate.setHours(0);
          startDate.setMinutes(0);
          startDate.setSeconds(0);

          picker.$emit('pick', [new Date(startDate), endDate]);
        }
      },
      {
        text: i18n.t('pickerOptions.shortcuts.yesterday'),
        onClick(picker) {
          console.log('test 4')
          const start = new Date();
          start.setDate(start.getDate() - 1);
          start.setHours(0);
          start.setMinutes(0);
          start.setSeconds(0);

          const end = new Date();
          end.setDate(end.getDate() - 1);
          end.setHours(23);
          end.setMinutes(59);
          end.setSeconds(59);

          if (chartName === 'TonalComment') {
            getMethod({method: TRUST_COMMENT_DAILY, title: this.text});
          } else {
            getMethod({method: TRUST_HOURLY, title: this.text});
          }

          picker.$emit('pick', [new Date(start), new Date(end)]);
        }
      },
      {
        text: i18n.t('pickerOptions.shortcuts.day'),
        onClick(picker) {
          console.log('test 5')
          if (chartName === 'TonalComment') {
            getMethod({method: TRUST_COMMENT_DAILY, title: this.text});
          } else {
            getMethod({method: TRUST_HOURLY, title: this.text});
          }

          const endDate = new Date();
          const startDate = endDate.setHours(endDate.getHours() - 24);

          picker.$emit('pick', [new Date(startDate), new Date()]);
        }
      },
      {
        text: i18n.t('pickerOptions.shortcuts.7day'),
        onClick(picker) {
          const start = new Date();
          start.setDate(start.getDate() - 6);
          start.setHours(0);
          start.setMinutes(0);
          start.setSeconds(0);

          const end = new Date();

          end.setHours(23);
          end.setMinutes(59);
          end.setSeconds(59);

          if (chartName === 'TonalComment') {
            getMethod({method: TRUST_COMMENT_DAILY, title: this.text});
          } else {
            getMethod({method: TRUST_DAILY, title: this.text});
          }

          picker.$emit('pick', [new Date(start), new Date(end)]);
        }
      },
      {
        text: i18n.t('pickerOptions.shortcuts.14day'),
        onClick(picker) {
          const start = new Date();
          start.setDate(start.getDate() - 13);
          start.setHours(0);
          start.setMinutes(0);
          start.setSeconds(0);

          const end = new Date();

          end.setHours(23);
          end.setMinutes(59);
          end.setSeconds(59);

          if (chartName === 'TonalComment') {
            getMethod({method: TRUST_COMMENT_DAILY, title: this.text});
          } else {
            getMethod({method: TRUST_DAILY, title: this.text});
          }

          picker.$emit('pick', [new Date(start), new Date(end)]);
        }
      },
      {
        text: i18n.t('pickerOptions.shortcuts.30day'),
        onClick(picker) {
          const start = new Date();
          start.setDate(start.getDate() - 29);
          start.setHours(0);
          start.setMinutes(0);
          start.setSeconds(0);

          const end = new Date();

          end.setHours(23);
          end.setMinutes(59);
          end.setSeconds(59);

          if (chartName === 'TonalComment') {
            getMethod({method: TRUST_COMMENT_DAILY, title: this.text});
          } else {
            getMethod({method: TRUST_DAILY, title: this.text});
          }

          picker.$emit('pick', [new Date(start), new Date(end)]);
        }
      },
      {
        text: i18n.t('pickerOptions.shortcuts.all'),
        onClick(picker){
          const start = new Date(retrospective);
          const end = new Date();

          if (chartName === 'TonalComment') {
            getMethod({method: TRUST_COMMENT_DAILY, title: this.text});
          } else {
            getMethod({method: TRUST_PERIOD, title: this.text});
          }

          picker.$emit('pick', [start, end]);
        }
      },
    ]
  };
};
